import { mixpanelTrack } from "utils/tracking/mixpanel";

export function trackEmail(email: string, state?: string) {
  mixpanelTrack("lead_added", {
    $email: email,
    location: state === "MO" ? "Missouri domestic" : "state closed",
  });
}
